import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgSearch = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M1 6.718q0 1.187.447 2.227a5.85 5.85 0 0 0 3.083 3.048q1.05.444 2.24.443a5.6 5.6 0 0 0 1.687-.253 6 6 0 0 0 1.489-.71l3.254 3.225a1 1 0 0 0 .347.225 1.12 1.12 0 0 0 .95-.063.97.97 0 0 0 .368-.373q.135-.239.135-.534 0-.21-.078-.4a.9.9 0 0 0-.22-.33l-3.232-3.218q.503-.688.787-1.524a5.3 5.3 0 0 0 .29-1.763 5.4 5.4 0 0 0-.453-2.213 5.7 5.7 0 0 0-1.24-1.826A5.73 5.73 0 0 0 6.77 1a5.7 5.7 0 0 0-4.076 1.679 5.8 5.8 0 0 0-1.247 1.826A5.5 5.5 0 0 0 1 6.718m1.51 0q0-.87.326-1.637a4.3 4.3 0 0 1 2.282-2.255 4.2 4.2 0 0 1 1.652-.33q.886 0 1.659.33.772.324 1.354.907.589.582.921 1.348.333.765.333 1.637 0 .877-.333 1.644a4.3 4.3 0 0 1-2.275 2.255q-.772.33-1.659.33-.879 0-1.652-.33a4.4 4.4 0 0 1-1.36-.907 4.3 4.3 0 0 1-.922-1.348 4.15 4.15 0 0 1-.326-1.644"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSearch);
export default ForwardRef;
